import agendas from '@octanner-ui/tanner-ui-icons/js/agendas.js';
import team from '@octanner-ui/tanner-ui-icons/js/group.js';
import calendar from '@octanner-ui/tanner-ui-icons/js/calendar.js';
import cog from '@octanner-ui/tanner-ui-icons/js/settings.js';
import heart from '@octanner-ui/tanner-ui-icons/js/heart-filled.js';
import star from '@octanner-ui/tanner-ui-icons/js/star-filled.js';
import bulletPoints from '@octanner-ui/tanner-ui-icons/js/menu-dots.js';
import goal from '@octanner-ui/tanner-ui-icons/js/goal.js';
import globe from '@octanner-ui/tanner-ui-icons/js/globe.js';
import avatarCircle from '@octanner-ui/tanner-ui-icons/js/avatar-circle.js';
import chart from '@octanner-ui/tanner-ui-icons/js/chart.js';
import document from '@octanner-ui/tanner-ui-icons/js/document.js';
import yearbook from '@octanner-ui/tanner-ui-icons/js/yearbook.js';
import arrowSmallDown from '@octanner-ui/tanner-ui-icons/js/arrow-small-down.js';
import releases from '@octanner-ui/tanner-ui-icons/js/releases.js';
import announcements from '@octanner-ui/tanner-ui-icons/js/announcements.js';
import check from '@octanner-ui/tanner-ui-icons/js/check.js';
import close from '@octanner-ui/tanner-ui-icons/js/close.js';
import notification from '@octanner-ui/tanner-ui-icons/js/notification.js';
import arrowSmallRight from '@octanner-ui/tanner-ui-icons/js/arrow-small-right.js';
import shoppingCart from '@octanner-ui/tanner-ui-icons/js/shopping-cart.js';
import lock from '@octanner-ui/tanner-ui-icons/js/lock.js';
import invoiceSpreadsheet from '@octanner-ui/tanner-ui-icons/js/invoice-spreadsheet.js';
import informationCircle from '@octanner-ui/tanner-ui-icons/js/information-circle';
import dashboards from '@octanner-ui/tanner-ui-icons/js/dashboard';
import report from '@octanner-ui/tanner-ui-icons/js/reporting';
import align from './icons/align.js';
import recognitionCap from './icons/recognition-cap.js';
import liveStats from './icons/livestats.js';
import groupDeposits from './icons/group-deposits.js';
import styles from '../menu/menu.css';

const iconsIndex = {
  align,
  agendas,
  team,
  schedule: calendar,
  ADMIN_HOME: cog,
  EMPLOYEE_ACTIVITY_HISTORY: team,
  DATA_EXPORT_TOOL: chart,
  BUDGET_MANAGEMENT: document,
  YEARBOOK: yearbook,
  INVOICE_SPREADSHEET: invoiceSpreadsheet,
  calendar,
  cog,
  heart,
  star,
  bulletPoints,
  goal,
  globe,
  avatarCircle,
  arrowSmallDown,
  arrowSmallRight,
  check,
  close,
  notification,
  shoppingCart,
  lock,
  report,
  PRODUCT_ROADMAP: releases,
  PRODUCT_UPDATES: announcements,
  informationCircle,
  DASHBOARDS: dashboards,
  REPORTING: report,
  RECOGNITION_MANAGEMENT: recognitionCap,
  LIVE_STATS: liveStats,
  ADMIN_GROUP_DEPOSITS: groupDeposits
};

const icon = (key) => {
  if (iconsIndex[key]) {
    return `<svg class=${styles.iconContainer} focusable="false" width="16px" height="16px" viewBox="0 0 16 16" >${iconsIndex[key]}</svg>`;
  }
  return '';
};

export default icon;
